import React, { SetStateAction } from 'react';

import {
  Box,
  Menu,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from '@mui/material';

import { BowlIcon, JarIcon } from '../../../utils/iconRefs/recipeStepsIcons';
import {
  LocationEnum,
  SUB_STEP_TITLE_PLACEHOLDER,
  SubStepTypeEnum,
} from '../utils/constants';

const LocationSelector = ({
  location,
  setLocation,
  titleText,
  setTitleText,
  handleLocationSelect,
  instructionType,
  setInstructionType,
}: {
  location: string;
  setLocation: React.Dispatch<string>;
  titleText: string | null;
  setTitleText: React.Dispatch<string | null>;
  handleLocationSelect: (event: SelectChangeEvent) => void;
  instructionType: string;
  setInstructionType: React.Dispatch<SetStateAction<string>>;
}) => (
  <>
    <Select
      label=""
      onChange={handleLocationSelect}
      sx={{ height: '48px', width: '170px', mt: '20px' }}
      value={
        instructionType === SubStepTypeEnum.INSTRUCTION
          ? LocationEnum.JAR
          : location
      }
    >
      <MenuItem
        value={LocationEnum.BOWL}
        disabled={instructionType === SubStepTypeEnum.INSTRUCTION && true}
      >
        <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
          <BowlIcon />
          <Typography variant="card">In a Bowl</Typography>
        </Box>
      </MenuItem>

      <MenuItem value={LocationEnum.JAR}>
        <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
          <JarIcon />
          <Typography variant="card">In the Jar</Typography>
        </Box>
      </MenuItem>

      <MenuItem
        value={LocationEnum.NONE}
        disabled={instructionType === SubStepTypeEnum.INSTRUCTION && true}
      >
        <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
          <Typography variant="card">None</Typography>
        </Box>
      </MenuItem>
    </Select>

    <textarea
      defaultValue={titleText ?? ""}
      onBlur={(e) => setTitleText(e.target.value)}
      placeholder={SUB_STEP_TITLE_PLACEHOLDER}
      style={{
        minWidth: '100%',
        maxWidth: '100%',
        maxHeight: '150px',
        minHeight: '60px',
        fontSize: '16px',
        fontWeight: 400,
        fontFamily: 'Nunito Sans',
        padding: '10px',
        boxSizing: 'border-box',
      }}
      typeof="text"
    />
  </>
);
export default LocationSelector;
